import { useEffect, useEffectEvent } from "react"
import { useIdle } from "react-use"

import { useAnalytics, userEventsMap } from "../core/Root/analytics"
import { useModal } from "../core/Root/modal-root"
import { DialogIdle } from "./dialog-idle"
import { useProcessingTimeEvents } from "./track-processing-time"

type Props = {
  contactId: string
  idleTimeout: number
}

export function useIdleAgent({ contactId, idleTimeout }: Props) {
  const { showModal } = useModal()
  const { isPaused, pause, resume } = useProcessingTimeEvents(contactId)
  const { trackEvent } = useAnalytics()

  const isIdle = useIdle(idleTimeout)

  const handleIdle = useEffectEvent(async () => {
    if (isIdle && !isPaused) {
      pause()
      await showModal<boolean>((close) => (
        <DialogIdle close={close} idleTimeout={idleTimeout} />
      ))
      resume()
      trackEvent(userEventsMap.resume_work)
    }
  })

  useEffect(() => {
    handleIdle()
  }, [isIdle])
}
